import React from 'react';
import { TooltipContent } from './TooltipContent';
import { Popover } from '../../Popover';
export var Tooltip = function (_a) {
    var title = _a.title, disableHover = _a.disableHover, className = _a.className, popoverRootClassName = _a.popoverRootClassName, children = _a.children;
    return (React.createElement(Popover, { popoverClassName: popoverRootClassName, disableHover: disableHover, content: React.createElement(TooltipContent, { title: title, className: className }) }, children));
};
